import { Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../services/context/AppContext';
import { useEffect, useState } from 'react';
import { getValue, STORAGE_KEYS } from '../services/Storage';
import HeartRateLoader from '../components/HeartRateLoader';

const Layout = () => {
    const { isLoggedIn, error,isTokenVerified } = useAppContext();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!isLoggedIn && isTokenVerified) {
            navigate('/', { state: { claimReturnTo: location.pathname }, replace: true });
        }
    }, [isLoggedIn,isTokenVerified,location.pathname,navigate]);

    if (!isLoggedIn) {
        return <HeartRateLoader />
    }

    return <div className="d-flex">
        <Outlet />
    </div>;
};

export default Layout;
